const initialState: IDataMapperFlowState = {
    data: null,
    row: 0, // Zero-based array
    clickConnecting: false,
};

export default function DataMapperFlowReducer(
    state: IDataMapperFlowState = initialState,
    action: IDataMapperFlowAction | IDataMapperFlowClearAction | IDataMapperFlowClickConnecting,
): IDataMapperFlowState {
    switch (action.type) {
        case "IDATA_MAPPER_FLOW":
            return {
                ...state,
                ...action.payload,
            };
        case "IDATA_MAPPER_FLOW_CLEAR":
            return {
                data: null,
                row: 0,
                clickConnecting: false,
            };
        case "IDATA_MAPPER_FLOW_CLICK_CONNECTING":
            return {
                ...state,
                clickConnecting: action.payload || false,
            };
        default:
            return state;
    }
}
